// This file was generated by the build-public-api.ts script
export * from './components/add-customer-to-group-dialog/add-customer-to-group-dialog.component';
export * from './components/address-card/address-card.component';
export * from './components/address-detail-dialog/address-detail-dialog.component';
export * from './components/customer-detail/customer-detail.component';
export * from './components/customer-group-detail-dialog/customer-group-detail-dialog.component';
export * from './components/customer-group-list/customer-group-list.component';
export * from './components/customer-group-member-list/customer-group-member-list.component';
export * from './components/customer-history/customer-history.component';
export * from './components/customer-list/customer-list.component';
export * from './components/customer-status-label/customer-status-label.component';
export * from './components/select-customer-group-dialog/select-customer-group-dialog.component';
export * from './customer.module';
export * from './customer.routes';
export * from './providers/routing/customer-resolver';
